import { customElement } from 'lit/decorators.js'
import { html, css, LitElement } from 'lit'

@customElement('zaptic-spinner')
export class Spinner extends LitElement {
    static styles = css`
        :host {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .spinner {
            border-radius: 50%;
            border-style: solid;
            border-width: var(--Spinner-thickness, 4px);
            border-color: var(--Spinner-color, var(--grey5) var(--grey5) var(--grey5) var(--grey7));
            will-change: transform;
            animation: spinner-animation var(--Spinner-speed, 1s) infinite linear;
            height: var(--Spinner-size, 20px);
            width: var(--Spinner-size, 20px);
            margin: 5px;
        }

        @keyframes spinner-animation {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    `

    render() {
        return html`<div class="spinner"></div>`
    }
}
